import { render, staticRenderFns } from "./remediationAdmin.vue?vue&type=template&id=85371452&scoped=true"
import script from "./remediationAdmin.vue?vue&type=script&lang=js"
export * from "./remediationAdmin.vue?vue&type=script&lang=js"
import style0 from "./remediationAdmin.vue?vue&type=style&index=0&id=85371452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85371452",
  null
  
)

export default component.exports